<template>
    <!--弹窗-->
    <el-dialog width="500px" title="关键词" :visible.sync="visible" :before-close="handleDialogClose" top="5vh" append-to-body>
        <el-form ref="formData" :inline="true" size="mini">
            <el-form-item label="关键词:" class="query-form-item">
                <div class="keywordEditor">
                    <div class="keywordEditor__inputRow">
                        <el-input
                            style="width: 330px;"
                            clearable
                            v-model="keywordInput"
                            placeholder="输入关键词后点击添加（或回车）"
                            size="mini"
                            @keyup.enter.native="addTag"
                        ></el-input>
                        <el-button size="mini" type="primary" style="margin-left:8px;" @click="addTag">添加</el-button>
                    </div>
                    <div class="keywordEditor__tags">
                        <el-tag
                            v-for="(tag, index) in tags"
                            :key="index"
                            closable
                            @close="removeTag(index)"
                            @click.native="clickTag(tag)"
                            style="margin:0 10px 10px 0; cursor: pointer;"
                        >
                            {{ tag }}
                        </el-tag>
                    </div>
                </div>

                <div class="historyTags" v-if="historyTags && historyTags.length">
                    <div class="historyTags__title">历史关键词：</div>
                    <div class="historyTags__list">
                        <el-tag
                            v-for="(tag, index) in historyTags"
                            :key="'history-' + index"
                            effect="plain"
                            style="margin:0 10px 10px 0; cursor: pointer;"
                            @click.native="clickHistoryTag(tag)"
                        >
                            {{ tag }}
                        </el-tag>
                    </div>
                </div>
            </el-form-item>
        </el-form>

        <el-row style="margin-top:17px;">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">关 闭
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm(true)">确 定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                keyWord: '',
                visible: false,
                tags: [],
                keywordInput: '',
                historyTags: [],
            }
        },
        methods: {
            openModal(existingKeywords = []) {
                this.visible = true
                const list = existingKeywords.map(item => item.keyword || item).filter(Boolean)
                this.tags = []
                this.historyTags = []
                list.forEach(kw => {
                    if (!this.historyTags.includes(kw)) {
                        this.historyTags.push(kw)
                    }
                })
                this.keywordInput = ''
            },
            handleDialogClose(done) {
                this.handleClose(false)
                if (typeof done === 'function') {
                    done()
                }
            },
            addTag() {
                if (this.keywordInput.trim() !== '') {
                    const kw = this.keywordInput.trim()
                    if (!this.tags.includes(kw)) {
                        this.tags.push(kw)
                    }
                    this.keywordInput = ''
                }
            },
            removeTag(index) {
                this.tags.splice(index, 1)
            },
            clickTag(tag) {
                this.keywordInput = tag
            },
            clickHistoryTag(tag) {
                this.keywordInput = tag
            },
            // 保存信息
            submitForm() {
                if (this.tags.length > 0 || this.historyTags.length > 0) {
                    this.handleClose(true, this.tags)
                } else {
                    this.$message.info('关键词不能为空')
                }
            },
            // 关闭弹窗
            handleClose(flag = false, tags = null) {
                let arr = []
                if (flag) {
                    const finalTags = tags || this.tags
                    const merged = ([]
                        .concat(this.historyTags || [])
                        .concat(finalTags || []))
                        .map(item => (item || '').trim())
                        .filter(item => item !== '')
                    const unique = Array.from(new Set(merged))

                    const currentDate = this.getYMDString()
                    arr = unique.map(item => ({
                        keyword: item,
                        date: currentDate
                    }))
                }
                this.$emit('close-callback', {flag: flag, keyWord: arr})
                this.tags = []
                this.historyTags = []
                this.keywordInput = ''
                this.visible = false
            },
            getYMDString() {
                var now = new Date();
                var year = now.getFullYear();
                var month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的
                var day = now.getDate().toString().padStart(2, '0');
                return year + '-' + month + '-' + day;
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .keywordEditor {
        width: 450px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        padding: 8px;
        min-height: 80px;
        max-height: 200px;
        overflow-y: auto;
        
        &__tags {
            margin-top: 8px;
        }
        
        &__inputRow {
            display: flex;
            align-items: center;
        }
    }

    .historyTags {
        margin-top: 12px;
        padding-top: 8px;
        border-top: 1px dashed #e4e7ed;

        &__title {
            font-size: 12px;
            color: #909399;
            margin-bottom: 8px;
        }

        &__list {
            max-height: 120px;
            overflow-y: auto;
        }
    }

    .subTitle {
        font-size: 16px;
        font-weight: 900;
        margin: 20px 0;
    }

    .top1 {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .top1Right {
            display: flex;
            flex-wrap: wrap;
            width: 1200px;

            .itemInfo {
                width: 360px;
                display: flex;
                height: 28px;
                line-height: 28px;

                .itemTitle {
                    font-size: 14px;
                    color: #606266;
                    padding: 0 12px 0 0;
                    font-weight: 900;
                }

                .itemContent {
                    width: 230px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }

    .top3 {
        display: flex;
        justify-content: space-between;
        width: 600px;

        .top3Left {
            width: 100px;
            height: 120px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;

            button {
                margin-top: 10px;
            }
        }

        .top3Right {
            width: 400px;

        }
    }

    .top4 {
        .line1, .line2, .line4, .line3 {
            display: flex;
            justify-content: start;
        }

        .itemInfo {
            width: 25%;
            display: flex;
            height: 28px;
            line-height: 28px;
            margin-bottom: 10px;

            .itemTitle {
                font-size: 14px;
                color: #606266;
                padding: 0 12px 0 0;
                font-weight: 900;
            }

            .itemContent {
                max-width: 230px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .line4 {
            .line4Left, .line4Right {
                width: 50%;
            }

            .itemInfo {
                width: 100%;
            }
        }

    }

    .content {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #cecfd1;
        font-size: 12px;
        color: #000;

        .shu {
            border-right: 1px solid #cecfd1;
        }

        .content-div {
            width: 50%;
            padding: 25px 20px;
        }

        .content-buttom {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cecfd1;
            padding-bottom: 8px;
            margin-bottom: 10px;
        }

        .content-buttom-txet {
            color: rgb(57, 187, 252);
            cursor: pointer;
        }

        .content-data {
            width: 100%;
            height: 230px;
            overflow: auto;

            .content-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;

                .cha {
                    cursor: pointer;
                    font-size: 15px;
                    color: rgb(158, 192, 209);
                    margin: 0 10px 0 12px;
                }
            }
        }

        /deep/ .content-data::-webkit-scrollbar {
            width: 3px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-track-piece {
            background-color: #ffff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
            width: 3px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }

    .media-txt {
        font-size: 15px;
        color: #6a6c6f;
        font-weight: 600;
        margin-bottom: 8px;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 12px !important;
    }
</style>
